import api from './api'

const IOT_API = 'iot'

// IoT Device Management API
export const getIoTDevices = (modalityId) => 
  api.getResource(`${IOT_API}/modalities/${modalityId}/devices`)

export const registerIoTDevice = (modalityId, deviceData) => 
  api.postResource(`${IOT_API}/modalities/${modalityId}/devices/register`, deviceData)

export const updateIoTDevice = (modalityId, deviceId, deviceData) => 
  api.putResource(`${IOT_API}/modalities/${modalityId}/devices/${deviceId}`, deviceData)

export const removeIoTDevice = (modalityId, deviceId) => 
  api.deleteResource(`${IOT_API}/modalities/${modalityId}/devices/${deviceId}`)

// Token Management API
export const getTokenStatus = (modalityId, deviceId) => 
  api.getResource(`${IOT_API}/modalities/${modalityId}/devices/${deviceId}/token-status`)

export const extendToken = (modalityId, deviceId, extensionData) => 
  api.postResource(`${IOT_API}/modalities/${modalityId}/devices/${deviceId}/extend-token`, extensionData)

export const getExpiredTokens = (modalityId) => 
  api.getResource(`${IOT_API}/modalities/${modalityId}/devices/expired-tokens`)
